// import { AxiosExpress } from '@/utils/axios';
import {
  AxiosClient,
  AxiosClientServerNuxt,
  AxiosExpress,
} from "../../utils/axios";
import { RCS } from "@/utils/ConstantRouter";
import { logError } from "../../utils/logError";
import Axios from "axios";
let currentMajorName = "";
export const state = () => ({
  list_school: [],
  current_page: 1,
  current_page_search: 1,
  current_page_filter: 1,
  current_page_filter_tuition: 1,
  total_item_school: 0,
  introduction: "",
});

export const mutations = {
  LIST_SCHOOL(state, payload) {
    state.list_school = payload;
  },
  LIST_SCHOOL_HOME_PAGE(state, payload) {
    state.list_school_home_page = payload;
  },
  LIST_SCHOOL_HOME_PAGE_FILTER(state, payload) {
    state.list_school_home_page_filter = payload;
  },
  CURRENT_PAGE(state, payload) {
    state.current_page = payload;
  },
  CURRENT_PAGE_SEARCH(state, payload) {
    state.current_page_search = payload;
  },
  CURRENT_PAGE_FILTER(state, payload) {
    state.current_page_filter = payload;
  },
  CURRENT_PAGE_FILTER_TUITION(state, payload) {
    state.current_page_filter_tuition = payload;
  },
  TOTAL_ITEM_SCHOOL(state, payload) {
    state.total_item_school = payload;
  },
  INTRODUCTION(state, payload) {
    state.introduction = payload;
  },
};

export const actions = {
  async getListSchool({ commit, state, rootState }, payload) {
    let { type, majorName } = payload;
    let { page_size, valueSearch, provinceId, dataTuition, showMore, page } =
      payload.params;
    let url = "";
    // page = 1;
    // page > 1
    let showMoreInt = showMore === true ? 1 : 0;
    if (
      type === "default" ||
      (valueSearch === "" && provinceId === "" && dataTuition === "")
    ) {
      url = `?page_size=${page_size}&page=${page}`;
    }
    // search page =1;
    // search page > 1;
    else if (type === "search") {
      url = `?name=${valueSearch}&page_size=${page_size}&page=${page}`;
    }
    // filter page = 1;
    // filter page > 1;
    else if (type === "filter") {
      url = `?province_id=${provinceId}&page_size=${page_size}&page=${page}`;
    } else {
      url = `?filter_by_tuition=${dataTuition}&page_size=${page_size}&page=${page}`;
    }

    if (currentMajorName !== majorName) {
      commit("LIST_SCHOOL", []);
      currentMajorName = majorName;
    }
    return await AxiosExpress.get(
      `api${RCS.LIST_SCHOOL}/${url}&majorName=${majorName}`,
      {}
    )
      .then((res) => {
        let { data, metadata } = res?.data;
        // default
        if (type === "default") {
          commit("LIST_SCHOOL", data);
          handleCommit(commit, metadata?.current_page, 1, 1, 1);
        } else if (type === "search") {
          commit("LIST_SCHOOL", data);
          handleCommit(commit, 1, metadata?.current_page, 1, 1);
        } else if (type === "filter") {
          commit("LIST_SCHOOL", data);
          handleCommit(commit, 1, 1, metadata?.current_page, 1);
        } else {
          commit("LIST_SCHOOL", data);
          handleCommit(commit, 1, 1, 1, metadata?.current_page);
        }
        commit("TOTAL_ITEM_SCHOOL", metadata?.total_items);
        commit("CURRENT_PAGE", metadata?.current_page);
        commit("INTRODUCTION", res?.data?.introduction);
      })
      .catch((error) => {
        logError(error, "getEventDetail on store");
      });
  },

  async getListYourSchool({ commit, state, rootState }) {
    try {
      const isOnServer = process.server;

      let res;
      if (isOnServer) {
        res = await AxiosClientServerNuxt.get(`/eduzone/api/school/your-school`, {});
      } else {
        res = await AxiosClient.get(`/eduzone/api/school/your-school`, {});
      }

      commit("LIST_SCHOOL_HOME_PAGE", res.data);
      return res;
    } catch (e) {
      logError(e, "getListYourSchool on store");
      return e;
    }
  },
  async getListSearchSchool({ commit, rootState }, { page, limit, filter }) {
    try {
      const isOnServer = process.server;
      const domain = this.$config.BASE_URL_CLIENT;
      let res;
      if (isOnServer) {
        res = await AxiosClientServerNuxt.get(
          `/eduzone/api/school/get-list-school?page=${page}&limit=${limit}&filter=${filter}`,
          {}
        );
      } else {
        res = await Axios.get(
          `${domain}/api/school/get-list-school?page=${page}&limit=${limit}&filter=${filter}`,
          {}
        );
      }
      // const res = await AxiosClientServerNuxt.get(
      //   `/api/school/get-list-school?page=${this.page}&limit=${this.limit}&filter=${this.selectedFilter}`
      // );

      const { listSchool } = res.data;
      if (this.selectedFilter === this.prevFilter) {
        this.searchSchoolResult = [...this.searchSchoolResult, ...listSchool];
      } else {
        this.searchSchoolResult = listSchool;
      }
      commit("LIST_SCHOOL_HOME_PAGE_FILTER", this.searchSchoolResult);
      return res;
    } catch (e) {
      logError(e, "getListSearchSchool on store");
      return e;
    }
  },
};

const handleCommit = (
  commit,
  CURRENT_PAGE,
  CURRENT_PAGE_SEARCH,
  CURRENT_PAGE_FILTER,
  CURRENT_PAGE_FILTER_TUITION
) => {
  commit("CURRENT_PAGE", CURRENT_PAGE);
};
